// extracted by mini-css-extract-plugin
export default {"section":"Section_section__g-uwV","noBackground":"Section_noBackground__N-s33"};